// homeShow already selects the homepage campaigns; keep its order and original IDs.
export function getHomeActivities(result) {
    const items = result && result.eventManageList
    return Array.isArray(items) ? items.filter(item => item && item.eventType && item.eventType !== 'customerServiceTelegram' && typeof item.homeImgUrl === 'string' && item.homeImgUrl.trim()) : []
}
